import { Box } from "@chakra-ui/react";
import { FC } from "react";
import { Asset } from "lib/types";
import { md } from "lib/utils";

export const DisplayTextAsset: FC<{ asset: Asset<any>}> = ({ asset }) => (
  <Box
    fontSize={["md"]}
    layerStyle={"with-markdown-content"}
    dangerouslySetInnerHTML={{ __html: md.render(asset.data.value) }}
    className="markdown__text"
  />
);
